/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_social_profiles14 = /** @type {(inputs: {}) => string} */ () => {
	return `Social Profiles`
};

const fr_social_profiles14 = /** @type {(inputs: {}) => string} */ () => {
	return `Profils sociaux`
};

const de_social_profiles14 = /** @type {(inputs: {}) => string} */ () => {
	return `Profile in sozialen Netzwerken`
};

const es_social_profiles14 = /** @type {(inputs: {}) => string} */ () => {
	return `Perfiles sociales`
};

const it_social_profiles14 = /** @type {(inputs: {}) => string} */ () => {
	return `Profili sociali`
};

const ar_social_profiles14 = /** @type {(inputs: {}) => string} */ () => {
	return `الملفات الاجتماعية`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const social_profiles14 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.social_profiles14(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("social_profiles14", locale)
	if (locale === "en") return en_social_profiles14(inputs)
	if (locale === "fr") return fr_social_profiles14(inputs)
	if (locale === "de") return de_social_profiles14(inputs)
	if (locale === "es") return es_social_profiles14(inputs)
	if (locale === "it") return it_social_profiles14(inputs)
	return ar_social_profiles14(inputs)
};
export { social_profiles14 as "SOCIAL_PROFILES" }